/*
 * @Desc:组件封装包
 * @Author: 吴影茹
 */
import Empty from './Empty/index.vue'
import ChapterSelect from './ChapterSelect/index.vue'
import BackButton from './BackButton/index.vue'
import tinymce from "./overall/tinymce/index.vue";
import KnowledgeSelect from "./Resource/KnowledgeSelect.vue";
import CoursewareSelect from "./Resource/CoursewareSelect.vue";
import QuestionSelect from "./Resource/QuestionSelect.vue";
import PaperSelect from "./Resource/PaperSelect.vue";
import VideoModal from "./Resource/VideoModal.vue";
import AudioModal from "./Resource/AudioModal.vue";
import Attachment from "./Attachment/index.vue";

function ComCommon(Vue) {
    Vue.component("OyEmpty", Empty);
    Vue.component("ChapterSelect", ChapterSelect);
    Vue.component("BackButton", BackButton);
    Vue.component("OyTinymce", tinymce);
    Vue.component("KnowledgeSelect", KnowledgeSelect);
    Vue.component("CoursewareSelect", CoursewareSelect);
    Vue.component("QuestionSelect", QuestionSelect);
    Vue.component("PaperSelect", PaperSelect);
    Vue.component("VideoModal", VideoModal);
    Vue.component("AudioModal", AudioModal);
    Vue.component("OyAttachment", Attachment);
}
export default ComCommon;
